// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1eGDT","inputWrap":"CustomTip_inputWrap__17XMp"};